import { render } from "./PlanningMedical.vue?vue&type=template&id=f8d24ea8&scoped=true"
import script from "./PlanningMedical.vue?vue&type=script&lang=js"
export * from "./PlanningMedical.vue?vue&type=script&lang=js"

import "./PlanningMedical.vue?vue&type=style&index=0&id=f8d24ea8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d24ea8"]])

export default __exports__